import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 380px;
  }
  .text-pairing-body {
    max-width: 517px;
    line-height: 32px;
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 507px;
    }
    .text-pairing-body {
      max-width: 517px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 544px;
    }
    .text-pairing-body {
      max-width: 544px;
    }
  }
`;

export const MainBackgroundImage = styled(Flex)<{
  backgroundImage: string;
}>`
  background-color: #ffffff;
  width: 100%;
  height: 1260px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  padding-top: 10px;
  background: url(${props => cloudAssetUrl(props.backgroundImage, { optimization: 'mild', isResizeDisabled: true })}) no-repeat center
    center;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: contain;
  padding-top: ${themeSpace(11)};

  ${themeMediaQuery('below_sm')} {
    height: 780px;
    background-size: 190%;
    background-position: -124px bottom;
  }
  ${themeMediaQuery('sm')} {
    height: 1120px;
  }
  ${themeMediaQuery('md')} {
    height: 1350px;
  }
  @media (min-width: 1400px) {
    height: 1460px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    height: 1240px;
  }
  ${themeMediaQuery('lg')} {
    height: 1550px;
  }
  ${themeMediaQuery('xl')} {
    height: 1750px;
  }
  @media (min-width: 1920px) {
    height: 1790px;
  }
`;

export const StyledMobileSection = styled(Box)`
  position: relative;
  width: 100vw;
`;

export const StyledBox = styled(Flex)`
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    width: 90vw;
  }
  ${themeMediaQuery('sm')} {
    width: max-content;
  }
`;

export const skewHWRatio = 0.3;

export const StyledJoyPercentage = styled(Box)`
  position: relative;
  perspective: 10px;
`;

export const StyledJoyPercentageImg = styled(CloudImage)`
  position: relative;
`;

export const NoFeeCashEverWrapper = styled(Flex)`
  opacity: 0.9;
  border-radius: 27px;
  width: 100%;
  position: relative;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    justify-content: space-around;
    height: 100px;
    margin-bottom: 150px;
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
  }
`;

export const StyledColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding: 0px;
  }
`;
